import { ReactNode, useCallback, useMemo } from "react";
import { SideBarContainer } from "../../../../../../../../components/SideBarContainer";
import { BankAccountForm } from "../../BankAccountForm";

export const useOpenSideBar = (
  selectedItem: any | null,
  showAddAndNewButton: boolean,
  isPrimaryDisabled: boolean,
  customerId: string,
  setSelectedItem: React.Dispatch<React.SetStateAction<any>>,
  fetchData: () => void,
) => {
  const setShowSideBar = useCallback(
    (_: boolean) => setSelectedItem(undefined),
    [setSelectedItem],
  );

  const close = useCallback(
    () => setSelectedItem(undefined),
    [setSelectedItem],
  );

  const sideBar: ReactNode = useMemo(() => {
    const title: string = selectedItem
      ? "Bank Account Details"
      : "Add Bank Account";

    return (
      <SideBarContainer title={title} setShowSideBar={setShowSideBar}>
        <BankAccountForm
          selectedItem={selectedItem}
          showAddAndNewButton={showAddAndNewButton}
          isPrimaryDisabled={isPrimaryDisabled}
          reload={fetchData}
          close={close}
          customerId={customerId}
        />
      </SideBarContainer>
    );
  }, [
    selectedItem,
    setShowSideBar,
    showAddAndNewButton,
    isPrimaryDisabled,
    fetchData,
    close,
    customerId,
  ]);

  return { sideBar };
};
